module.exports = __webpack_public_path__ + "img/TrialPlus.71a3c17b.png";